import React, { FC } from 'react';
import { CustomerServiceOutlined } from '@ant-design/icons';
import { Divider } from 'antd';

const CustomFooter: FC = () => {
  return (
    <div>
      <div style={{ display: 'flex', alignContent: 'center' }}>

        {/* <CustomerServiceOutlined style={{ fontSize: 30, marginTop: -7 }} /> */}
        {/* <div style={{ marginLeft: 10, marginTop: -12 }}>
          <div>
            客服热线
          </div>
          <div >
            010-010010010
          </div>
        </div> */}
        <>
          <a style={{ color: 'white', fontSize: 20, marginLeft: 10, marginTop: -12 }} href="http://px.5gwlhtg.com/p/includes/about_5">关于我们</a>
          {/*2021/12/20 只保留“关于我们“ */}
          {/* <Divider type="vertical" />
          <a style={{ color: 'white', fontSize: 20, marginLeft: 10, marginTop: -12 }} href="http://kaixt.cn/p/includes/contact_5g">联系我们</a>
          <Divider type="vertical" />
          <a style={{ color: 'white', fontSize: 20, marginLeft: 10, marginTop: -12 }} href="http://kaixt.cn/p/help/help">帮助</a> */}
        </>
      </div>
      <a href="https://beian.miit.gov.cn/">京ICP备16051938号-6</a>
    </div>
  )
};

export default CustomFooter;
